import * as React from 'react';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { Box, Stack } from '@mui/material';
import { formatAddress } from '../../../utils/address';

export default function WarehouseInfo({ data, id }) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMouseEnter = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMouseLeave = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const popoverId = open ? 'warehouse-info-popover' : undefined;

  if (!data && !id) return null;

  return (
    <>
      <Typography variant="body2" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} sx={{ color: 'text.secondary', cursor: 'pointer' }}>
        Warehouse: [{id ?? data?.id ?? '-'}] {data?.alias ?? ''}
      </Typography>
      <Popover
        id={popoverId}
        open={open}
        anchorEl={anchorEl}
        onClose={handleMouseLeave}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        sx={{
          pointerEvents: 'none',
        }}
        disableRestoreFocus
      >
        <Box sx={{ p: 2 }}>
          {data ? (
            <Stack direction="column" sx={{ gap: 1 }}>
              <Typography variant="body2" sx={{ fontWeight: 700 }}>
                [{data.id || ''}] {data.alias || ''}
              </Typography>
              <Typography variant="body2">{formatAddress(data.address)}</Typography>
              <Typography variant="body2">
                [{data?.address?.lat || ''}, {data?.address?.lng || ''}]
              </Typography>
            </Stack>
          ) : (
            <Typography variant="body2" sx={{ fontWeight: 700 }}>
              Warehouse ID: {id || '-'}
            </Typography>
          )}
        </Box>
      </Popover>
    </>
  );
}
